import { createFileRoute } from "@tanstack/react-router";
import { ReviewDashboardView } from "@/lib/features/admin/ReviewDashboardView";
export const Route = createFileRoute("/_app/admin/granska/")({
  component: ReviewDashboardView
});